
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/home-medical-care/[videoId]",
      function () {
        return require("private-next-pages/special/home-medical-care/[videoId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/home-medical-care/[videoId]"])
      });
    }
  